import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAccountIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 36,
	height: 37,
	viewBox: "0 0 36 37",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M18 3.25C9.7155 3.25 3 9.9655 3 18.25C3 26.5345 9.7155 33.25 18 33.25C26.2845 33.25 33 26.5345 33 18.25C33 9.9655 26.2845 3.25 18 3.25ZM18 7.375C20.6925 7.375 22.875 9.5575 22.875 12.25C22.875 14.9425 20.6925 17.125 18 17.125C15.3075 17.125 13.125 14.9425 13.125 12.25C13.125 9.5575 15.3075 7.375 18 7.375ZM18 30.25C14.343 30.25 11.0685 28.6135 8.868 26.032C8.2965 25.3615 8.424 24.355 9.1275 23.8255C11.403 22.114 15.549 21.25 18 21.25C20.451 21.25 24.597 22.114 26.874 23.8255C27.5775 24.355 27.705 25.363 27.1335 26.032C24.9315 28.6135 21.657 30.25 18 30.25Z",
		fill: "currentColor"
	})
});
export default SvgAccountIcon;
